var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"header-wrapper"},[_c('ShortHeader')],1),_c('v-main',{staticClass:"home",attrs:{"id":"home","data-testid":"elem_u_000609"}},[_vm._t("default")],2),_c('div',{staticClass:"footer-wrapper"},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }